var plugin_rtlignore_default = {
  "alignLeft": "MQEHd",
  "textWrapNowrap": "-vh32",
  "alignRight": "etFw6",
  "alignCenter": "Fq2UF",
  "sizeFullWidth": "_1WFwz",
  "renderedInTable": "_0JAkA",
  "sizeOriginal": "aErt7",
  "sizeContent": "_37nZt",
  "sizeSmall": "QsR3e",
  "sizeSmallCenter": "f2347",
  "flex": "MFj8S",
  "atomic": "zVy-A",
  "embed": "iOsOo",
  "horizontalScrollbar": "-yCSY",
  "pluginContainerMobile": "KD6hu"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
